import http from '@/api/http'

import { TGetMyAccountResponse, TUpdateMyAccountParams } from './types'

export const getMyAccount = async () => {
  const response = await http.get<TGetMyAccountResponse>(
    '/users/myaccount/getme/'
  )
  return response.data
}

export const updateMyAccount = async (data: TUpdateMyAccountParams) => {
  const response = await http.put<TGetMyAccountResponse>(
    '/users/myaccount/updateme/',
    data
  )
  return response.data
}
